import { css } from '@emotion/core'
import * as React from 'react'

import Image from './Image'

export const DefinitionCard: React.FC<{
  title: string
  description: string
  isTldrBox?: boolean
}> = ({ title, description, isTldrBox }) => {
  const isTldr = isTldrBox || title.toUpperCase() === 'TL;DR'
  return (
    <div css={borderStyle}>
      <div className="gray-bg-block" css={containerStyle}>
        {!!isTldr ? (
          <Image src="icons/tldr.webp" alt={title ? title : description} css={imageStyle} />
        ) : (
          <span className="heading4">💬</span>
        )}
        <h2 className="title black" css={titleStyle}>
          {title}
        </h2>
        <p className="body-1">{description}</p>
      </div>
    </div>
  )
}

const borderStyle = css`
  width: fit-content;
  background: var(--blue-gradient);
  padding: 2px;
  border-radius: 0.6rem;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
`

const containerStyle = css`
  justify-content: space-between;
  align-self: stretch;
  padding: 2rem;
  align-items: left;
  text-align: left !important;
  border: none !important;
`

const titleStyle = css`
  margin-bottom: 0.75rem !important;
  padding-bottom: 0;
`

const imageStyle = css`
  width: 2rem;
  margin-bottom: 0.5rem;
`
